// LAYOUT
import '../layout.js';

// SWIPER
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

var swiper = new Swiper(".banner__swiper", {
	modules: [Navigation, Pagination],
	slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
});


document.addEventListener("DOMContentLoaded", function(){
    let navbar_height = document.querySelector('.navbar').offsetHeight;
    let homeBanner = document.querySelector('.banner');
    homeBanner.style.marginTop = navbar_height - 3 + 'px';
});